﻿"use strict";

const urgentMessage = {
  init: function () {
    this.el = document.querySelector("[data-set-cookie]");
    this.sub = document.querySelector(".subnav");
    this.html = document.querySelector(".html")

    if (this.el) {
      this.attribute = this.el.getAttribute("data-set-cookie");
      this.name = this.attribute.split("=")[0];
      this.version = this.attribute.split("=")[1];

      this.events();
    }
  },

  events: function () {
    var self = this;

    this.el.addEventListener("click", function () {
      document.getElementsByClassName(self.name).remove()

      self.setCookie();
    });
  },

  setCookie: function () { 
    var self = this;

    document.cookie = self.attribute + "; expires=" + new Date(new Date().getFullYear() + 1, 1, 1).toUTCString() +  "; path=/";
  }

};

export default urgentMessage.init();
